<template>
  <label :class="classObject">
    <div class="switcher__label switcher__label--top"
      :class="{ 'switcher__label--disabled': disabled }"
      v-if="shouldShowLabel && labelLoc == 'top'"
      v-text="label">
    </div>

    <input type="checkbox"
      :disabled="disabled"
      @change="toggle"
      :checked="value"
    >

    <div class="switcher__track">
      <span class="switcher__slider"></span>
    </div>

    <span class="switcher__label switcher__label--right"
      :class="{ 'switcher__label--disabled': disabled }"
      v-if="shouldShowLabel && labelLoc == 'right'"
      v-text="label">
    </span>
  </label>
</template>

<script>
export default {
  name: 'switcher',
  props: {
    typeBold: {
      default: true,
      type: Boolean
    },
    value: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    label: {
      default: '',
      type: String
    },
    labelLoc: {
      default: 'right',
      type: String,
      validator: (v) => {
        return ['top', 'right'].indexOf(v) !== -1
      }
    },
    color: {
      default: 'default',
      type: String
    }
  },
  methods: {
    toggle(e) {
      this.$emit('input', !this.value)
    }
  },
  computed: {
    classObject ({ color, value, typeBold, disabled, labelLoc }) {
      return {
        'switcher': true,
        'layout--column': labelLoc == 'top',
        'layout--row': labelLoc == 'right',
        ['switcher--unchecked']: !value,
        ['switcher--disabled']: disabled,
        ['switcher--bold']: typeBold,
        ['switcher--bold--unchecked']: typeBold && !value
      }
    },
    shouldShowLabel () {
      return this.label !== '' || this.textEnabled !== '' || this.textDisabled !== '';
    }
  }
}
</script>

<style lang="scss" scoped>
.switcher {
  position: relative;
  display: flex;
  padding: 5px 0px;

  &.layout--column {
    flex-direction: column;
  }

  &.layout--row {
    flex-direction: row;
    align-items: center;
  }

  &__label {
    font-size: 10px;
    margin-bottom: 5px;
    &--right {
      font-size: 12px;
      padding-left: 7px;
      margin-bottom: 0px;
    }
    &--disabled {
      opacity: 0.5;
    }
  }

  input {
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    cursor: pointer;
  }

  &__track {
    height: 15px;
    width: 36px;
    position: relative;
    border-radius: 30px;
    display: -webkit-flex;
    display: -ms-flex;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    transition: linear .2s, background-color linear .2s;
    background-color: #00d1b2;

    .switcher__slider {
      height: 20px;
      width: 20px;
      border-radius: 100px;
      display: block;
      transition: linear .15s, background-color linear .15s;
      position: absolute;
      left: 100%;
      margin-left: -18px;
      cursor: pointer;
      top: -3px;
      box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
      background-color: #038d78;
    }
  }

  &--unchecked {
    .switcher__track {
      justify-content: flex-end;
      background: #f1f1f1;
      
      .switcher__slider {
        left: 15px;
        background-color: #adadad;
        opacity: 0.5;
      }
    }
  }

  &--disabled {
    .switcher__track {
      opacity: 0.3;
    }

    input {
      cursor: default;
    }
  }

  &--bold {
    .switcher__track {
      height: 26px;
      width: 51px;

      .switcher__slider {
        margin-left: -24px;
        top: 3px;
      }
    }

    &--unchecked {
      .switcher__track {

        .switcher__slider {
          left: 28px;
        }
      }
    }
  }

}
</style>
